import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { removeOrganisation } from '@api/organisations';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { ESnackbarTypes } from '@enums/common';

import { ORGANISATIONS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRemoveSingleOrganisation = (onSettledCallbacks?: Array<() => void>) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleDeleteOrganisation,
		isLoading: isLoadingDeleteOrganisation,
	} = useMutation({
		mutationKey: [ORGANISATIONS],
		mutationFn: removeOrganisation,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.removedOrganisation,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([ORGANISATIONS]);
		},
		onError: (err: IResponseError) => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			handleErrorFromMessage(err);
		},
	});

	return {
		handleDeleteOrganisation: handleDeleteOrganisation as unknown as (id: string) => void,
		isLoadingDeleteOrganisation,
	};
};
